import React, { useState } from "react";
import {
  IoFilterSharp,
  IoFilterOutline,
  IoArrowForwardSharp,
  IoArrowBackSharp,
} from "react-icons/io5";
import { FiDownload, FiEdit2 } from "react-icons/fi";
import {
  FaPlus,
  FaArrowRight,
  FaRegTrashAlt,
  FaSearch,
  FaFilter,
} from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import "../../../college/teachers/teacher.css";
import {
  Table,
  Button,
  Container,
  Row,
  Col,
  Pagination,
  Image,
  Badge,
  Card,
  Modal,
  InputGroup,
  FormControl,
  Dropdown,
} from "react-bootstrap";
import { useQuery, useQueryClient, useMutation } from "react-query";
import api from "../../../../utils/helper";
import { useIDsContext } from "../../../../context/IDsContext";
import { URLS } from "../../../../utils/URL";
import { BadgesComponent } from "../../../../components/BadgeRenderer";
import "../../../../media.css";
import "../../../vendor/students/student.css";
import "../../../teacher/students/student.css";
import { useNavigate, useLocation } from "react-router-dom";
import Delete from "../../../../components/Delete";
import { useAlerts } from "../../../../context/AlertContext";

const TeacherProfileModal = ({ show, onHide, teacher }) => {
  const courses = [
    {
      title: "Some course title",
      optedOn: "28/09/2024",
      duration: "2 Hours",
      progress: 40,
      status: "In Progress",
    },
    {
      title: "Some course title",
      optedOn: "28/09/2024",
      duration: "2 Hours",
      progress: 70,
      status: "In Progress",
    },
    {
      title: "Some course title",
      optedOn: "28/09/2024",
      duration: "2 Hours",
      progress: 100,
      status: "Completed",
    },
    {
      title: "Some course title",
      optedOn: "28/09/2024",
      duration: "2 Hours",
      progress: 10,
      status: "In Progress",
    },
  ];
  const navigate = useNavigate();
  const location = useLocation();
  const { vendorId, collegeName } = location.state || {};
  const { vendorID, collegeID } = useIDsContext();
  console.log("selectedVendor:", vendorID);
  const { vendorName } = useIDsContext();
  console.log("selectedvendorName:", vendorName);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10); // Adjust as needed
  const { showSuccess, showError } = useAlerts();
  const [showDelete, setShowDelete] = useState();
  const [teacherToDelete, setTeacherToDelete] = useState(null);
  const [teacherNameToDelete, setTeacherNameToDelete] = useState("");
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useQuery(
    ["teachers", vendorID, currentPage, itemsPerPage],
    () =>
      api.get(
        `/super-admin/teachers/vendor/${vendorID}?page=${currentPage}&limit=${itemsPerPage}`
      ),
    {
      enabled: !!vendorID,
      onError: (err) => {
        console.error(
          "Error fetching students:",
          err.response?.data?.message || err.message
        );
      },
    }
  );

  console.log(data, isLoading, error, "response");

  const [selectedStudent, setSelectedStudent] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const handleRowClick = (student) => {
    setSelectedStudent(student || {});
    setShowModal(true);
  };

  const [selectedTeacher, setSelectedTeacher] = useState([]);
  const [showAssignModal, setShowAssignModal] = useState(false);

  const [assignedCourses, setAssignedCourses] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const handleAssign = () => {
    setShowAssignModal(true);
    setShowModal(false);
  };

  const [courseType, setCourseType] = useState(null);
  const QueryClient = useQueryClient();

  const handleFilter = (type) => {
    console.log("HANDLE TYPE ", type);
    setCourseType(type);
    // The useQuery hook will automatically refetch when courseType changes
  };

  const clearFilter = () => {
    setCourseType(null);
    QueryClient.invalidateQueries("courses");
    // This will trigger a refetch of all courses without any filter
  };

  const deleteMutation = useMutation(
    (teacherID) => api.delete(`/super-admin/teachers/${teacherID}`),
    {
      onSuccess: (response) => {
        showSuccess(response.data?.message || "Deleted successfully!");
        console.log("Deleted successfully!", response);
        queryClient.invalidateQueries("teachers");
      },
      onError: (error) => {
        showError(error?.response?.data?.message || "Failed to deleted: ");
        console.log("Failed to deleted: " + error.message);
      },
    }
  );

  const handleDelete = (id, teacherName) => {
    // Store the ID to be deleted
    setTeacherToDelete(id);
    setTeacherNameToDelete(teacherName);
    setShowDelete(true);
  };

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        dialogClassName="modal-left"
        className="stus"
      >
        <Modal.Header closeButton>
          <Modal.Title className="suggestedCourse">Teacher Profile</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            {teacher ? (
              <div className="">
                <Row className="studentDetails m-0">
                  <Col
                    md={4}
                    className="d-flex justify-content-center align-items-center flex-column profileTeacher"
                  >
                    <Image
                      //src="/images/Avatar_6.png"
                      src={
                        teacher.profile_img
                          ? URLS.IMG_URL + teacher.profile_img
                          : "/images/Avatar_1.png"
                      }
                      roundedCircle
                      style={{
                        width: "100px",
                        height: "100px",
                        marginRight: "20px",
                      }}
                    />
                    <h5 className="mt-3 profileName">
                      {teacher?.firstname || "N/A"}
                      {teacher?.lastname || "N/A"}
                    </h5>
                    <p className="text-muted profileRollNo">
                      {selectedTeacher?.uid || "N/A"}
                    </p>
                    <img
                      src={
                        teacher.status === "Active"
                          ? "/images/_Badge base.png"
                          : selectedTeacher.status === "Inactive"
                          ? "/images/Badge.png"
                          : "/images/Badge (1).png"
                      }
                      alt="student Logo"
                      className="activity-status"
                    />
                  </Col>

                  <Col md={8} className="bgDetailes">
                    <div className="d-flex justify-content-end btnEdit mt-3">
                      <Button
                        variant="outline-secondary"
                        className="me-2 btnEditAlt"
                        onClick={() =>
                          navigate("/vendor/add-teacher", {
                            state: {
                              vendorId: vendorId,
                              teacher: teacher,
                              isEdit: true,
                            },
                          })
                        }
                      >
                        <FiEdit2 color="#344054" /> <span>Edit</span>
                      </Button>
                      <Button
                        variant="outline-danger"
                        className="btnTrashAlt"
                        onClick={() =>
                          handleDelete(teacher._id, teacher.firstname)
                        }
                      >
                        <FaRegTrashAlt />
                      </Button>
                    </div>
                    <Row>
                      <Col md={6} className="py-0">
                        <div className="">
                          <p className="profileEmail mb-0 fw-500 font-14">
                            Email:
                          </p>
                          <p className="profileVendor py-1">
                            {teacher?.email || "N/A"}
                          </p>
                        </div>
                        <div className="pt-4">
                          <p className="profileEmail mb-0 fw-500 font-14">
                            Vendor:
                          </p>
                          <p className="profileVendor  py-1">
                            {vendorName || teacher?.vendor || "N/A"}
                          </p>
                        </div>
                      </Col>
                      <Col md={6} className="py-0">
                        <div className="">
                          <p className="profileEmail mb-0 fw-500 font-14">
                            Phone:
                          </p>
                          <p className="profileVendor  py-1">
                            {selectedTeacher?.phone || "N/A"}
                          </p>
                        </div>
                        <div className="pt-4">
                          <p className="profileEmail mb-0 fw-500 font-14">
                            College:
                          </p>
                          <p className="profileVendor  py-1">
                            {teacher?.college?.name || "N/A"}
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            ) : (
              <p>No student selected.</p>
            )}

            <Row className="mt-4 p-3">
              <Col md={4}>
                <Card>
                  <Card.Body>
                    <p className="courseComplete">Courses Assigned</p>
                    <h2 className="family-inter  fw-500">
                      {teacher?.assignedCourses?.length || 0}
                    </h2>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={4}>
                <Card>
                  <Card.Body>
                    <p className="courseComplete">Student Assigned</p>
                    <h2 className="family-inter  fw-500">
                      {selectedTeacher?.studentAssigned || 0}
                    </h2>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={4}>
                <Card>
                  <Card.Body>
                    <p className="courseComplete">Average Activity Time</p>
                    <h2 className="family-inter fw-500">
                      {selectedTeacher?.averageActivityTime || "0 mins"}
                    </h2>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            {/* <Row className="p-3"> */}
            <Row className="mx-0">
              <div className="d-flex justify-content-between align-items-center p-1 px-4">
                <h2 className="suggestedCourse">Assigned Courses</h2>
              </div>

              {teacher?.assignedCourses?.length > 0 ? (
                teacher.assignedCourses.map((course, index) => {
                  return (
                    <Col md={6} key={index} className="p-2 px-4">
                      <Card
                        className="mb-3 course-cardes"
                        style={{ height: "100%" }}
                      >
                        <Card.Body className="p-0">
                          <div className="imagetext">
                            <Image
                              //src="/images/card_image.png"
                              src={
                                course?.thumbnail_img
                                  ? URLS.IMG_URL + course.thumbnail_img
                                  : "/images/Avatar_1.png"
                              }
                              className="cardimagelogo p-2"
                              alt={course?.name || "Course Image"}
                            />
                            <div
                              className="course-details p-2"
                              style={{
                                height: "100%",
                                minHeight: "100% !important",
                              }}
                            >
                              <div className="d-flex justify-content-between">
                                <h5 className="courseEngage">
                                  {course?.name || "Course Name"}
                                </h5>
                                <FaRegTrashAlt className="m-2" />
                              </div>
                              <p className="opted m-0">
                                Opted on:{" "}
                                {course?.createdAt
                                  ? new Date(
                                      course.createdAt
                                    ).toLocaleDateString()
                                  : "N/A"}
                              </p>
                              <p className="opted m-0">
                                Duration: {course?.duration || "N/A"}
                              </p>
                              <div className="p-0 d-flex">
                                <BadgesComponent badges={course?.tags} />
                              </div>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  );
                })
              ) : (
                <Col className="text-center py-4" style={{ marginTop: "8%" }}>
                  <p className="text-muted">No Assigned Courses</p>
                </Col>
              )}
            </Row>
          </Container>
        </Modal.Body>
      </Modal>

      <Delete
        show={showDelete}
        close={() => setShowDelete(false)}
        handleDelete={() => {
          deleteMutation.mutate(teacherToDelete);
          setShowDelete(false);
        }}
        title="Delete Teacher"
        name={teacherNameToDelete}
      />
    </>
  );
};

export default TeacherProfileModal;
